module.exports = __webpack_public_path__ + "static/media/loading.eec5c57e.svg";